
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuthContext } from 'src/auth/hooks';

const ProtectedRoute = ({ children, title, allowedRoles }) => {
  const auth = useAuthContext();
  const user = auth.user;
  const userRole = user?.roleType;
  
  const permissions = user?.permissions || [];


  // ✅ Bypass all checks if role is 1 (Super Admin)
  if (userRole === 1) {
    return children;
  }

  let hasPermission = true;

  if (title) {
    const [module, action] = title.split('.'); // e.g. enquiry.view

    hasPermission = permissions.some((perm) => {
      const matchTitle = perm?.title?.toLowerCase() === module?.toLowerCase();
      const isActive = perm?.status?.toLowerCase() === 'yes';

      if (!matchTitle || !isActive) return false;

      if (action) {
        return perm?.permission?.[action] === 'yes';
      }

      return true;
    });

    if (!hasPermission) {
      console.warn(`⛔ Access denied for title: ${title}`);
      return <Navigate to="/unauthorized" replace />;
    }
  }

  // Check allowedRoles (if any)
  if (allowedRoles?.length && !allowedRoles.includes(userRole)) {
    console.warn('⛔ Role not allowed:', userRole);
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  allowedRoles: PropTypes.arrayOf(PropTypes.number),
};

export default ProtectedRoute;
